// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-368446ba]{width:100%;background-color:#fff;border-radius:3px}", ""]);
// Exports
module.exports = exports;
